import storage from '@/utils/storage'
export default{
	state: {
		skuType:null
	},
	actions:{
	 	setSkuType ({commit}, skuType) {
      		commit('setSkuType', skuType);
   		},
	},
	mutations:{
	  	setSkuType (state,skuType) {
	    	storage.set('skuType', skuType);
	      	state.skuType = skuType;
	   	},
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/vm/index.js